export default __webpack_public_path__ + "static/media/computer-with-checklist.49b67e6c2ad79d2b6fb7de63668bfa52.svg";